<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Gtlu46/tc-custom/FC-9781645366089.jpg?1685203786583?1719603361324" alt="This image is the cover for the book Skinless"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Skinless
      </h1>
      <p class="bookDescription body article font2">
        <p><em>Skinless</em> takes place in New York City at the turn of the millennium. The plot combines elements of gritty TV drama (<em>The Sopranos</em>, <em>Dexter</em>, <em>Ray Donovan</em>) against a backdrop of small-time drug dealing and violence. <em>Skinless</em> tells the story of Charmay, a female survivor of sex abuse and teenage homelessness, who is caught in the grip of alcohol addiction. The reader follows her journey as she struggles to find her identity while trying to make it in the entertainment industry in New York City. She becomes entangled in a web of romance, passion, money, manipulation, and longing for intimacy. <em>Skinless</em> becomes a strange evocation of the turn of the 21st century in America—the times we live in and the forces we live by—a real-life portrayal of a world gone off its orbit.</p><p><br/></p><p>“Maggie Moor has a voice unlike any I’ve ever encountered. Both hip and illuminating. A voice that lifts the mind to a place it’s never been.”</p><p>– Kate Lardner, author of <em>Shut Up He Explained: The Memoir of a Blacklisted Kid</em> </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maggie Moor
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0mm;font-size:16px;font-family:"Times New Roman",serif;text-align:justify;'><span style="font-size:15px;color:black;background:white;">Maggie Moor is the author of<em>&nbsp;I Am: Your Guide to Mind and Body Union for Total Awareness</em>, and her psychoanalytic paper, <em>Coloring Outside the Lines: Sadomasochistic Defense and the Search for Identity,</em> was nominated for the NAAP Gradiva Award. She lives in New York City, where she is a licensed psychoanalyst and works with people recovering from trauma and addiction. Maggie is also a three-time national figure competitor and a jazz-rock singer/songwriter. She has recorded three albums with Grammy-award-winning musicians. <em>Skinless: The Story of a Female Survivor</em> is Maggie Moor&rsquo;s first fiction novel.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a131ac7